class EventOptionsExtractor {
    extract(data){
        return {
            contentTitle: data.attributes.name,
            entityID: data.id,
            entityType: 'Event HD',
            targetID: data.id,
        }
    }
}

class ClipOptionsExtractor {
    extract(data){
        return {
            contentTitle: data.attributes.name,
            entityID: data.id,
            entityType: 'Clip',
            targetID: data.attributes.eventId,
        }
    }
}

class PlayerHighlightOptionsExtractor {
    extract(data){
        return {
            contentTitle: data.attributes.name,
            entityID: data.id,
            entityType: 'Player highlight',
            targetID: data.attributes.eventId,
        }
    }
}

class AutohighlightOptionsExtractor {
    extract(data){
        return {
            contentTitle: data.attributes.name,
            entityID: data.id,
            entityType: 'Game highlight',
            targetID: data.attributes.eventId,
        }
    }
}

class DefaultExtractor {
    extract(){
        return {}
    }
}

class OptionsFactory {
    getExtractor(type){
        switch (type) {
            case 'clip':
                return new ClipOptionsExtractor();
            case 'autohighlight':
                return new AutohighlightOptionsExtractor();
            case 'hd':
            case 'pano':
                return new EventOptionsExtractor();
            case 'player-highlight':
                return new PlayerHighlightOptionsExtractor();
            default:
                return new DefaultExtractor();
        }
    }
}

class AnalyticOptionsExtractor {
    constructor() {
        this.factory = new OptionsFactory();
    }

    getAnalyticOptions (data) {
        const extractor = this.factory.getExtractor(data.type);

        return extractor.extract(data);
    }
}

export default new AnalyticOptionsExtractor();
